import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { footnoteDarkBgVars, footnoteVars } from './FootnoteBlock.palette';

export const snapFootnoteBlockLightVars: MotifComponentProps<MotifComponent.FOOTNOTE> = {
  ...footnoteVars,
  '--footnote-fg-color': m('--fg-color'),
  '--footnote-bg-color': m('--bg-color'),
  '--footnote-border-color': m('--neutral-v700'),
} as const;

export const snapFootnoteBlockDarkVars: MotifComponentProps<MotifComponent.FOOTNOTE> = {
  ...footnoteDarkBgVars,
  '--footnote-border-color': m('--neutral-v0'),
} as const;
